import Title from "@/components/common/Title";
import React from "react";
import ComponyOffer from "./ComponyOffer";
import InquirySection from "../InquirySection";
import Container from "@/components/common/Container";

export const WhyChooseOurServices = ({
  data,
  subTitle,
  subTitleClass,
  buttonName,
  id,
}) => {
  return (
    <Container large className="bg-primary-black pb-36 md:pb-40">
      <Title subTitle={subTitle} subTitleClass={subTitleClass} />
      <ComponyOffer data={data} />
      <InquirySection buttonName={buttonName} id={id} />
    </Container>
  );
};
